// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyDyN7tHHvaeafv9JWvmD9acimmx9ouCkvI',
  authDomain: 'slack-clone-b1ecf.firebaseapp.com',
  projectId: 'slack-clone-b1ecf',
  storageBucket: 'slack-clone-b1ecf.appspot.com',
  messagingSenderId: '959119361760',
  appId: '1:959119361760:web:11e7b248c393af34483285',
  measurementId: 'G-SXZVK6GL5R',
}

const cometChat = {
  APP_ID: '33214fd7206aee2',
  AUTH_KEY: '21339c95ac9e394ba98bb6efa2ab78829ff0afd7',
  REST_KEY: 'e738664fe512e2ba9ce2a2f87f003a226df01441',
  APP_REGION: 'us',
}

export { firebaseConfig, cometChat }
